function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M23.7017 0H21.3974C16.3937 0 13.4968 2.52308 13.4968 7.38461V16H21.3974V8.61539H17.4471V7.69231C17.4471 5.23077 18.7639 4 21.3974 4H23.7017V0ZM10.2049 0H7.90062C2.89693 0 6.10352e-05 2.52308 6.10352e-05 7.38461V16H7.90062V8.61539H3.95034V7.69231C3.95034 5.23077 5.2671 4 7.90062 4H10.2049V0Z",
  fill: "currentColor"
});
function SvgQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.0d1ec2e1.svg";
export { ForwardRef as ReactComponent };